import React from 'react';
import LOOKUP from 'constants/lookup';
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';
import DatePickerInput from 'screens/components/basic/DatePickerInput';

const statusOptions = [
    {
        text: "All",
        value: "None"
    },
    {
        text: "Opened",
        value: "1"
    },
    {
        text: "In Progress",
        value: "2"
    },
    {
        text: "Closed",
        value: "3"
    },
    {
        text: "Cancelled",
        value: "4"
    }
];

const searchFields = (props) => {
    return (
        <div className="row m-0">
            {/*Search Inputs*/}
            <div className="row m-0">
                <div className="col-sm-6 col-lg-3">
                    <TextInput
                        name={`${props.pageName}PoFilter`}
                        type="number"
                        className="search-field"
                        floatingLabelText={LOOKUP.purchaseOrder.filters.po.label}
                        label={LOOKUP.purchaseOrder.filters.po.label}
                        hintText={LOOKUP.purchaseOrder.filters.po.hintText}
                        onPressKey={props.search}
                    />
                </div>
                <div className="col-sm-6 col-lg-3">
                    <DatePickerInput
                        name={`${props.pageName}DueDateFilter`}
                        className="search-field"
                        label={LOOKUP.purchaseOrder.filters.dueDate.label}
                        floatingLabelText={LOOKUP.purchaseOrder.filters.dueDate.label}
                        hintText={LOOKUP.purchaseOrder.filters.dueDate.hintText} />
                </div>
                <div className="col-sm-6 col-lg-3">
                    <DatePickerInput
                        name={`${props.pageName}DateExpectedFilter`}
                        className="search-field"
                        label={LOOKUP.purchaseOrder.filters.dateExpected.label}
                        floatingLabelText={LOOKUP.purchaseOrder.filters.dateExpected.label}
                        hintText={LOOKUP.purchaseOrder.filters.dateExpected.hintText} />
                </div>
                <div className="col-sm-6 col-lg-3">
                    <SelectInput
                        name={`${props.pageName}Status`}
                        className="search-field"
                        label="Status"
                        floatingLabelText="Status"
                        defaultValue="None"
                        options={statusOptions} />
                </div>
            </div>
            <div className="row m-0">
                <div className="col-sm-6 col-lg-3">
                    <SelectInput
                        name={`${props.pageName}Supplier`}
                        className="search-field"
                        label="Supplier"
                        floatingLabelText="Supplier"
                        fullWidth={true}
                        options={props.loadVendorOptions} />
                </div>
                <div className="col-sm-6 col-lg-9 d-flex justify-content-end align-items-center">
                    <Button
                        type="IconSearchButton"
                        mini={true}
                        id="buttonSearchPO"
                        label={LOOKUP.employee.filters.filterButton}
                        className="btnNewBrandPOS btn-space"
                        onTouchTap={props.search} />
                    <Button
                        className="btnCleanSearch"
                        type="IconClearButton"
                        label={LOOKUP.employee.filters.cleanFilterButton}
                        onTouchTap={() => props.cleanSearch()} />
                </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p className='purpleText'><b>Note: </b><strong className="blue-text"><i>All uploaded Purchase Orders are set to Open status by default if auto receive is disabled. Edit the Purchase Order and change the status to On Order to begin receiving.</i></strong></p>
            </div>
        </div>
    );
};


export default searchFields;